import React, {useState} from "react";
import styled from "styled-components";
import * as palette from "../Variables";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Placeholder from "../img/placeholder.jpg";
import { BrowserRouter, Routes, Route } from 'react-router';

const StyledHomeWorkListing = styled.div`
    @media (min-width: 768px) {
        max-width: 100%;
    }

    &.left {
        @media (min-width: 576px) {
            margin-right: 16px;
        }

        @media (min-width: 768px) {
            margin-right: 24px;
        }
    }

    &.right {
        @media (min-width: 576px) {
            margin-left: 16px;
        }

        @media (min-width: 768px) {
            margin-left: 24px;
        }
    }

    a {
        font-weight: 400;
        transition: color 250ms ease;
        text-decoration: none;
        color: ${palette.neutral11};
        display: block;

            h3 {
                text-decoration: underline;
                text-decoration-style: solid;
                text-underline-offset: 6px;
                text-decoration-color: ${palette.neutral8};
            }

        &:hover, &:focus-visible {

            h3 {
                color: ${palette.pinkMain};
                text-decoration: underline;
                text-decoration-color: ${palette.pinkMain};
            }

            img {
                scale: 1.05;
            }
        }

        &:focus-visible {
            outline: 3px solid ${palette.blueMain};
            outline-offset: 8px;
            border-radius: 4px;
        }

        h3 {
            transition: all 250ms ease;
            display: inline;
        }
    }

    .description {
        margin-bottom: 0;
    }

    div.img-container {
        width: 100%;
        aspect-ratio: 3/2;
        overflow: hidden;
        border-radius: 8px;
        margin-bottom: 24px;

        @media (min-width: 768px) {
            margin-bottom: 32px;
        }

        img {
            width: 100%;
            aspect-ratio: 3/2;
            object-fit: cover;
            transition: all 350ms ease;
        }
    }

    .small.italic {
        color: ${palette.neutral9};
        margin-top: 4px;
        margin-bottom: 8px;

        @media (min-width: 768px) {
            margin-bottom: 12px;
        }
    }
`;

const HomeWorkListing = ({img, alt, title, label, description, className, href, dataAOS}) => {
    return (
        <StyledHomeWorkListing className={className}>
            <a href={href}>
                <div className={"img-container"}>
                    <img src={img} alt={alt}/>
                </div>
                <div data-aos={dataAOS} className={"title-container"}>
                    <h3 className={"h4"} data-aos={dataAOS}>{title}</h3>
                </div>
                <p className={"small italic"}>{label}</p>
                <p className={"description"}>{description}</p>
            </a>
        </StyledHomeWorkListing>
    )
}

export default HomeWorkListing;